import React from 'react';

const DateRangeDescription = (
  <div className="vads-u-margin-y--2">
    <va-details label="What if I have more than one date range?">
      You only need to enter one date range. We’ll use this information to find
      your record.
    </va-details>
  </div>
);

export default DateRangeDescription;
